import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  IconButton,
  Button,
  VStack,
  HStack,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
} from "@chakra-ui/react";


import emailjs from "@emailjs/browser";

import {
  MdPhone,
  MdEmail,
  MdLocationOn,
  
  MdOutlineEmail,
} from "react-icons/md";
import { BsGithub, BsPerson } from "react-icons/bs";
import { GrLinkedin } from "react-icons/gr";
import styles from "./Contact.module.css"
import { useRef, useState } from "react";

export function Contact() {
  const [data, setData] = useState({
    user_name: "",
    user_email: "",
    subject: "",
    message: "",
  });
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_jt3ynng",
        "template_49gwlh6",
        form.current,
        "HKBDlEZO8cItuZA7j"
      )
      .then(
        (result) => {
          console.log(result.text, "Message Sent Successfully!");
          setData({
            user_name: "",
            user_email: "",
            subject: "",
            message: "",
          });
          alert("Message Sent Successfully!");
        },
        (error) => {
          console.log(error.text);
          alert("Please try again!");
        }
      );
  };
  return (
    <div
      className={styles.contactme}
      id="contact"
      style={{ backgroundColor: "black", border: "1px solid black" }}
    >
      <Heading mb="1rem" textAlign={"center"} marginTop={"50px"}>
        Contact-Me
      </Heading>
      <Container
        className={styles.containerfg}
        maxW="full"
        mt={0}
        centerContent
        overflow="hidden"
      >
        <Flex>
          <Box
            bg="teal"
            // color="white"
            borderRadius="lg"
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",

            }}
            m={{ sm: 40, md: 0, lg: 10,  }}
            p={{ sm: 5, md: 5, lg: 16,  }}
            color="black"
          >
            <Box p={4}>
              <Wrap
                spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}
                color={"black"}
              >
                <WrapItem color={"black"}>
                  <Box color="black" fontSize={"20px"}>
                    <Heading color="balck">Contact</Heading>
                    <Text mt={{ sm: 3, md: 3, lg: 5 }} color="balck">
                      Fill up the form below to contact
                    </Text>
                    <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }}>
                      <VStack pl={0} spacing={3} alignItems="start">
                        <Button
                          size="md"
                          height="48px"
                          width="300px"
                          variant="ghost"
                          color="black"
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"initial"}
                          // alignItems={"left"}
                          _hover={{ border: "2px solid white" }}
                          leftIcon={
                            <MdPhone
                              color="black"
                              display={"flex"}
                              alignItems={"center"}
                              justifyContent={"initial"}
                              size="20px"
                            />
                          }
                        >
                          <a
                            id="contact-phone"
                            href="prachitiwari0911@gmail.com"
                          >
                            {" "}
                            91-7905721490
                          </a>
                        </Button>

                        <Button
                          size="md"
                          height="48px"
                          width="300px"
                          variant="ghost"
                          color="black"
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"initial"}
                          _hover={{ border: "2px solid white" }}
                          leftIcon={
                            <MdEmail
                              color="black"
                              display={"flex"}
                              alignItems={"center"}
                              justifyContent={"initial"}
                              size="20px"
                            />
                          }
                        >
                          <a
                            id="contact-email"
                            href="prachitiwari0911@gmail.com"
                          >
                            {" "}
                            prachitiwari0911@gmail.com
                          </a>
                        </Button>
                        <Button
                          size="md"
                          height="48px"
                          width="300px"
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"initial"}
                          variant="ghost"
                          color="black"
                          _hover={{ border: "2px solid white" }}
                          leftIcon={
                            <MdLocationOn
                              color="black"
                              size="20px"
                              display={"flex"}
                              alignItems={"center"}
                              justifyContent={"initial"}
                            />
                          }
                        >
                          Prayagraj{" "}
                          <span style={{ marginLeft: "5px" }}> (Up)</span>
                        </Button>
                      </VStack>
                    </Box>
                    <HStack
                      mt={{ lg: 10, md: 10 }}
                      spacing={20}
                      px={5}
                      alignItems="flex-start"
                    >
                      <a href="https://github.com/prachi913" target="_blank">
                        {" "}
                        <IconButton
                          id="contact-github"
                          aria-label="github"
                          variant="ghost"
                          size="lg"
                          isRound={true}
                          // _hover={{ background: "black" }}
                          icon={<BsGithub size="28px" background="black" />}
                        />
                      </a>

                      <a
                        // id="contact-linkedin"
                        href="https://www.linkedin.com/in/prachi-tiwari-1317b4240/"
                        target="_blank"
                      >
                        {" "}
                        <IconButton
                          id="contact-linkedin"
                          aria-label="discord"
                          variant="ghost"
                          size="lg"
                          background-color={"balck"}
                          isRound={true}
                          // _hover={{ background: "black" }}
                          icon={
                            <GrLinkedin size="28px" background-color="black" />
                          }
                        />
                      </a>
                    </HStack>
                  </Box>
                </WrapItem>
                <WrapItem>
                  <Box bg="white" borderRadius="lg">
                    <form ref={form} onSubmit={sendEmail}>
                      <Box m={8} color="#0B0E3F">
                        <VStack spacing={5}>
                          <FormControl id="name">
                            <FormLabel>Your Name</FormLabel>
                            <InputGroup
                              borderColor="#E0E1E7"
                              type="text"
                              value={data.user_name}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  user_name: e.target.value,
                                })
                              }
                              name="user_name"
                              placeholder="Name"
                              required
                              border={"1px solid black"}
                              borderRadius={"10px"}
                            >
                              <InputLeftElement
                                pointerEvents="none"
                                children={<BsPerson color="gray.800" />}
                              />
                              <Input type="text" size="md" />
                            </InputGroup>
                          </FormControl>
                          <FormControl id="name">
                            <FormLabel>Mail</FormLabel>
                            <InputGroup
                              borderColor="#E0E1E7"
                              type="email"
                              name="user_email"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  user_email: e.target.value,
                                })
                              }
                              value={data.user_email}
                              placeholder="Email"
                              required
                              border={"1px solid black"}
                              borderRadius={"10px"}
                            >
                              <InputLeftElement
                                pointerEvents="none"
                                children={<MdOutlineEmail color="gray.800" />}
                              />
                              <Input type="text" size="md" />
                            </InputGroup>
                          </FormControl>
                          <FormControl id="name">
                            <FormLabel>Message</FormLabel>
                            <Textarea
                              borderColor="gray.300"
                              _hover={{
                                borderRadius: "gray.300",
                              }}
                              placeholder="message"
                              name="message"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  message: e.target.value,
                                })
                              }
                              border={"1px solid black"}
                              borderRadius={"10px"}
                              value={data.message}
                              required
                            />
                          </FormControl>
                          <FormControl id="name" float="right">
                            <Button
                              variant="solid"
                              bg="black"
                              color="white"
                              _hover={{ color: "black", background: "teal" }}
                              type="submit"
                            >
                              Send Message
                            </Button>
                          </FormControl>
                        </VStack>
                      </Box>
                    </form>
                  </Box>
                </WrapItem>
              </Wrap>
            </Box>
          </Box>
        </Flex>
      </Container>
    </div>
  );
}
